function sanitize(givenString: string) {
  let sanitizedString = givenString;
  if (givenString) {
    sanitizedString = givenString.replace(/(<([^>]+)>)/gi, '');
  }
  return sanitizedString;
}

export default sanitize;
